/* global contact_app */

import map from 'lodash/map'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'

export default {
    mapLoad(){

        mapboxgl.accessToken = 'pk.eyJ1IjoiZ2JwZWxzaXMiLCJhIjoiY2szdWE3azZ2MGFpdTN1cHN6ZmtjMzVuYSJ9.7BOCzMBbz3sbp4UcVCu2VA'
		const mapL = new mapboxgl.Map({
			container: 'map-locations',
            style: 'mapbox://styles/gbpelsis/ck4419xq20o9c1co1kze2v7ww',
			center: [-1.5000702828890764,53.98293887316403],
			zoom: 3,
			scrollZoom: false,
		})

		const geojson = {
			'type': 'FeatureCollection',
			'features': [],
		}

		map(contact_app.locations, item => {
			if(item.latitude && item.longitude){

				let dataItem = {
					type: 'Feature',
					geometry: {
						type: 'Point',
						coordinates: [item.longitude, item.latitude],
					},
					properties: {
						title: item.title,
						address: item.address,
					},
				}
				geojson.features.push(dataItem)

			}
		})


		let squarebox = {
			min: [999999999999999, 999999999999999],
			max: [-999999999999999, -999999999999999],
		}

		map(contact_app.locations, item => {
			if(item.longitude < squarebox.min[0]){
				squarebox.min[0] = Number(item.longitude)
			}
			if(item.latitude < squarebox.min[1]){
				squarebox.min[1] = Number(item.latitude)
			}
			if(item.longitude > squarebox.max[0]){
				squarebox.max[0] = Number(item.longitude)
			}
			if(item.latitude > squarebox.max[1]){
				squarebox.max[1] = Number(item.latitude)
			}
		})

		const bbox = [
			[squarebox.min[0], squarebox.min[1]], 
			[squarebox.max[0], squarebox.max[1]],
		]

		mapL.on('load', () => {
			mapL.addSource('places', {
		      'type': 'geojson',
		      'data': geojson,
		    })

			fitMap(bbox)

			const zoomOut = document.querySelector('.zoom-out')
			zoomOut.addEventListener('click', e => {
				e.preventDefault()
				fitMap(bbox)
			})
		})

        geojson.features.forEach(function(marker, i) {
            let el = document.createElement('div')
            el.id = 'marker-' + i
            el.className = 'marker pointer-none'


		    new mapboxgl.Marker(el, {offset: [15, -30]})
		        .setLngLat(marker.geometry.coordinates)
		        .addTo(mapL)

		    el.addEventListener('click', function(e){
		        flyToStore(marker)
		        e.stopPropagation()
		    })
        })



	  	function fitMap(box){
				mapL.fitBounds(box, {
                    maxZoom: 12,
				  	padding: {
					  	top: 100, 
					  	bottom: 100, 
					  	left: 100, 
					  	right: 100,
				  	},
				})
	  	}


		function flyToStore(currentFeature) {
		    mapL.flyTo({
		        center: currentFeature.geometry.coordinates,
		        zoom: 12,
		        speed: 0.85,
		        pitch: 55,
		        bearing: -15,
		    })
		}


    },
    init(){
        this.mapLoad()
    }
}